import { TypedController, Value } from "@vytant/stimulus-decorators";
import { Controller } from "@hotwired/stimulus";
import { IntegrationAppClient } from "@integration-app/sdk";

@TypedController
export default class extends Controller {
  @Value(String) readonly integrationKeyValue: string;
  @Value(String) readonly modeValue: string;
  @Value(String) readonly tokenValue: string;

  connect() {
    const integrationApp = new IntegrationAppClient({ token: this.tokenValue });

    this.element.addEventListener("click", async () => {
      try {
        if (this.modeValue === "disconnect") {
          await integrationApp.connection(this.integrationKeyValue).archive();
        } else {
          await integrationApp.integration(this.integrationKeyValue).openNewConnection();
        }

        window.location.reload();
      } catch (error) {
        console.error("Error Integration app:", error);
      }
    });
  }
}
